// -----------------------------------------------------------
// PatInvalidPanel.jsx
// Terminal invalid-input guard for PAT-GPT
// -----------------------------------------------------------

import React from "react";

export default function PatInvalidPanel({ input, scope }) {
  const message =
    scope?.message ||
    "PAT-GPT could not identify a coherent analytic object in this input.";

  return (
    <div className="mt-6 p-5 border border-slate-700 rounded-xl text-sm text-gray-300 space-y-5 bg-slate-900/40">
      <div className="font-semibold text-amber-300 text-lg">
        Input not analysable in current form
      </div>

      <div className="rounded-lg border border-slate-700/70 bg-slate-950/40 p-3 space-y-2">
        <div className="text-indigo-300 text-xs uppercase tracking-wide">
          Input received
        </div>
        <div className="text-slate-100 whitespace-pre-wrap">{input || "—"}</div>
      </div>

      <div className="space-y-2">
        <div className="font-semibold text-indigo-300">
          PAT’s current reading
        </div>
        <div>{message}</div>
      </div>

      <div className="space-y-2">
        <div className="font-semibold text-indigo-300">
          Why PAT cannot repair this input
        </div>
        <div>
          PAT can repair meaningful non-causal, associative, diagnostic,
          semantic, explanatory, or malformed-causal inputs. It cannot infer X,
          Y, M, or Z from text that does not provide stable concepts, a
          meaningful relation, or a coherent analytic object.
        </div>
      </div>

      <div className="rounded-lg border border-amber-700/40 bg-amber-950/10 p-3 space-y-2">
        <div className="font-semibold text-amber-300">To continue</div>
        <div>
          Resubmit a meaningful question, claim, or candidate relation. If you
          intend causal analysis, include at least one potential cause,
          exposure, condition, or intervention, and one outcome that may change.
        </div>
      </div>

      {Array.isArray(scope?.examples_of_valid_inputs) &&
        scope.examples_of_valid_inputs.length > 0 && (
          <div className="rounded-lg border border-slate-700/70 bg-slate-950/30 p-3 space-y-2">
            <div className="font-semibold text-indigo-300">
              Example admissible forms
            </div>
            <ul className="list-disc list-inside ml-2 space-y-1 text-slate-300">
              {scope.examples_of_valid_inputs.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}

      <div className="text-slate-400 text-xs leading-relaxed">
        This guard prevents PAT from hallucinating causal structure where no
        analysable input is available. It is separate from the non-causal repair
        gate, which is reserved for meaningful inputs that are not yet in
        Pearlian causal form.
      </div>
    </div>
  );
}
